<div class="map-container">
  <div
    class="map"
    leaflet
    [leafletOptions]="mapService.options"
    (leafletMapReady)="onMapReady($event)"
  ></div>
  @if (loading() || isRendering()) {
    <div class="loading-progress">
      <mat-progress-spinner
        color="accent"
        mode="indeterminate"
        diameter="50"
      ></mat-progress-spinner>
    </div>
  }
</div>
